import type {FetchError} from 'ofetch';
import {showError, defineNuxtPlugin, useUniversalPost, useRoute, useUniversalFetch} from '#imports';

export default defineNuxtPlugin({
    dependsOn: ['fetch-auth'],
    async setup(nuxtApp) {
        nuxtApp.hooks.hookOnce('page:finish', async () => {
            // MT-385 & MT-387: enable Prismic preview
            // Enable by-pass for /slice-simulator and /cms/prismic/preview
            const route = useRoute();
            if (route.meta?.cookieVerifierSkip) {
                return;
            }

            try {
                // Context:
                // On Sentry v1 module, the configuration was fetched in `/api/sentry/config`.
                // This was the first API call made by SSR apps on client, so this is the call that could setup all the cookies (XSRF, visitorId, etc.)
                // As cookie verifier call ran after the sentry config call, there was no problem.
                //
                // Upgrading to Sentry v2 module removed the need to fetch the Sentry config.
                // The problem was that on SSR apps, on client, the first API call was the cookie verifier call, so the cookies were not setup.
                // Resulting in a 403 error and a error page.
                // With the new Sentry module, a forced call to `/api/user/current-session` is made to populate the cookies.
                if (nuxtApp.payload.serverRendered) {
                    try {
                        await useUniversalFetch('/api/user/current-session');
                    } catch {
                        // best-effort cookie priming; still attempt verify below
                    }
                }

                await useUniversalPost('/cookie-verify', {baseURL: '/'});
            } catch (e) {
                const error = e as FetchError;
                if (error.status === 403) {
                    showError({message: '(cookie-verifier) Cookie are not working properly', data: {type: 'cookie-verify'}});
                }
            }
        });
    },
});
